// removed by extract-text-webpack-plugin
module.exports = {"menuIcon":"style__menuIcon___15TzC","menuBottom":"style__menuBottom___2iv4L","menuBottomTitle":"style__menuBottomTitle___3mS0Z","menuBottomIcons":"style__menuBottomIcons___26nun","menuBottomIconsItem":"style__menuBottomIconsItem___3qTbl","menuBottomIconsItemEmail":"style__menuBottomIconsItemEmail___n1EhS","menuBottomIconsItemWhatsApp":"style__menuBottomIconsItemWhatsApp___3l1BO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/main/style.css
// module id = 428
// module chunks = 0